import React from 'react'

import DateFilter from '../../../../components/filter/DateFilter'
import PlacesFilter from '../../../../containers/places/filters/PlacesFilter'
import ScreenViewFilterBar from '../../../../containers/screenViews/ScreenViewFilterBar'

const FiltersBar = ({ open }) => {
  return (
    <ScreenViewFilterBar screen="formReplies" open={open}>
      <PlacesFilter label="Local/Pessoa" full placeField="placeIds" placeLevelField="placeLevelIds" />
      <DateFilter label="Criação" field="insertedAt" />
    </ScreenViewFilterBar>
  )
}

export default FiltersBar
